import os from 'os';
// TODO: use untildify instead?
export function filePathToNodeFormat(filePath) {
    if (filePath.startsWith('~/')) {
        return filePath.replace('~', os.homedir());
    }
    else {
        return filePath;
    }
}
//# sourceMappingURL=filePathToNodeFormat.js.map